let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8dO9q")).then(() => parcelRequire('1KwlE'));